import { Box, Dialog } from '@mui/material';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';
import styled from 'styled-components';

export const DialogStyled = styled(Dialog)`
  border-radius: ${SIZES.spacing(1)};
`;

export const ModalHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${SIZES.spacing(1)};
  border-bottom: 1px solid ${COLORS.border.main};

  svg {
    cursor: pointer;
  }
`;

export const ImageWrapper = styled(Box)`
  img {
    width: 100%;
    height: 100%;
  }
`;
